import React from 'react'
import PhoneIcon from '../IconPhone'
import IconArrowUpRight from '../IconArrowUpRight/IconArrowUpRight'
import IconDialogBalloon from '../IconDialogBalloon/IconDialogBalloon'
import styled from 'styled-components'
import IconShieldLinear from '@/components/icons/IconShieldLinear/IconShieldLinear'
import ActionChip from '@/components/atoms/ActionChip/ActionChip'
import useSegment from '../../hooks/segment/useSegment'
import { isObject } from '../../utils/checks'

// workaround because tailwind custom breakpoints are not working
const CallLink = styled.div`
  @media (max-width: 386px) {
    display: none;
  }
`

const CardFooter = ({
  handleCardPhoneNumberDataLayerClick,
  recordAlgoliaConversion,
  phoneNumber,
  slug,
  handleDataLayerInquiryClick,
  handleClick,
  __queryID,
  objectID,
  userID,
  currentRefinements,
  hideCallButton
}) => {
  const analytics = useSegment()

  const isInsurancePage = currentRefinements?.accepted_insurance
  const isInsuranceAcceptedPage =
    currentRefinements?.price?.includes('Insurance Accepted') || false

  const handleCallClick = () => {
    analytics.ui.callCta({
      ...phoneNumber,
      center_slug: slug
    })
    handleCardPhoneNumberDataLayerClick()
    recordAlgoliaConversion({
      objectID,
      queryID: __queryID,
      userID,
      event: 'ListingPageCall',
      referrer: window.location.pathname
    })

    if (window.dataLayer) {
      window.dataLayer.push({
        center_slug: slug,
        form_type: 'mobile_call',
        form_location: 'in_feed',
        event: 'mobile_call'
      })
    }
  }

  return (
    <div
      className="rounded-br-12 rounded-bl-3 rounded-tl-0 rounded-tr-0 mx-4 flex flex-1 border-t 
      border-solid border-gray-200 bg-white py-4 text-sm font-medium text-gray-1100"
    >
      <div className="flex w-full items-center gap-2 text-sm font-medium">
        <ActionChip
          label="View"
          onClick={handleClick}
          as="a"
          dataGroup="view-center"
          className={`view-center-button`}
          href={`/${slug}/`}
          target="_blank"
          appendIcon={<IconArrowUpRight size="md" />}
        />

        {isInsuranceAcceptedPage || isInsurancePage ? (
          <ActionChip
            label="Verify Insurance"
            dataGroup="verify-insurance"
            as="a"
            href={`/${slug}/#profile-insurance`}
            prependIcon={
              <IconShieldLinear
                size="md"
                strokeWidth="2"
              />
            }
          />
        ) : (
          <ActionChip
            label="Message"
            onClick={(e) => {
              handleDataLayerInquiryClick()
              handleClick()
            }}
            as="a"
            dataGroup="message-center"
            href={`/${slug}/#message`}
            prependIcon={<IconDialogBalloon size="md" />}
          />
        )}

        <CallLink>
          {!hideCallButton && isObject(phoneNumber) && (
            <ActionChip
              label="Call"
              onClick={() => handleCallClick()}
              as="a"
              href={`tel:${phoneNumber.number}`}
              aria-label={`call ${phoneNumber.number}`}
              prependIcon={<PhoneIcon size="md" />}
              className="md:hidden"
              dataGroup="call-center"
            />
          )}
        </CallLink>
      </div>
    </div>
  )
}

export default CardFooter
